export enum ReservationStatus {
    waiting = process.env.VUE_APP_STATUS_WAITING_ON_MEETING_POINT,
    onWayToPoint = process.env.VUE_APP_STATUS_ON_WAY_TO_MEETING_POINT,
    onBoard = process.env.VUE_APP_STATUS_CUSTOMER_ON_BOARD,
    noShow = process.env.VUE_APP_STATUS_NO_SHOW,
    completed = process.env.VUE_APP_STATUS_COMPLETED
}